{
  "title": "System-Status",
  "voice_install": {
    "title": "Voice Interface installieren",
    "lxc_hint": "Läuft als incus-LXC (kein Docker)",
    "download_hint": "Modelle/Stimmen werden heruntergeladen (~0,5–1 GB)",
    "ports_hint": "STT läuft auf Port 10300, TTS (Piper) auf Port 10200",
    "autostart_hint": "Container starten automatisch bei jedem System-Neustart",
    "log_title": "Installations-Log",
    "log_empty": "Warte auf Log-Ausgabe…",
    "running": "Installation läuft — incus-Container + Modelle werden eingerichtet…",
    "starting": "Installation wird gestartet…",
    "done_msg": "Voice Interface erfolgreich installiert — STT Port 10300 · TTS Port 10200",
    "failed": "Installation fehlgeschlagen",
    "unknown_error": "Unbekannter Fehler",
    "cancel": "Abbrechen",
    "install": "Installieren"
  },
  "subtitle": "Auto-Refresh alle {{seconds}}s",
  "subtitle_with_uptime": "Auto-Refresh alle {{seconds}}s · läuft seit {{uptime}}",
  "stats": {
    "agents": "Agents",
    "agents_detail": "{{count}} {{type}}",
    "projects": "Projekte",
    "projects_detail": "{{count}} aktiv",
    "sessions": "Sessions",
    "sessions_detail": "{{count}} aktiv",
    "messages": "Messages",
    "messages_detail": "{{count}} Compactions",
    "tool_calls": "Tool-Calls",
    "tool_calls_detail": "{{rate}}% Success",
    "db_size": "DB-Größe",
    "db_size_detail": "sessions.db",
    "python": "Python",
    "version": "Version",
    "version_detail": "HydraHive"
  },
  "paths": {
    "title": "Pfade",
    "data": "Data",
    "config": "Config",
    "db": "DB"
  },
  "checks": {
    "db": "DB",
    "db_ok": "lesbar/schreibbar",
    "llm": "LLM",
    "llm_no_config": "Keine Config",
    "llm_no_model": "Kein Default-Model",
    "llm_no_provider": "Keine Provider",
    "llm_ok": "{{model}} · {{count}} Provider",
    "workspaces": "Workspaces",
    "workspaces_missing": "Verzeichnis fehlt",
    "disk": "Disk",
    "disk_detail": "{{free_gb}} GB frei ({{free_pct}}%)"
  },
  "uptime": {
    "seconds": "{{n}}s",
    "minutes": "{{m}}m {{s}}s",
    "hours": "{{h}}h {{m}}m",
    "days": "{{d}}d {{h}}h"
  },
  "agentlink": {
    "title": "AgentLink",
    "not_configured": "AgentLink nicht konfiguriert",
    "not_configured_hint": "HH_AGENTLINK_URL setzen damit ask_agent zwischen Agenten vermitteln kann.",
    "connected": "verbunden",
    "disconnected": "getrennt",
    "url": "REST",
    "ws": "WebSocket",
    "agent_id": "Agent-ID",
    "timeout": "Handoff-Timeout",
    "known_agents": "Bekannte Agents ({{count}})",
    "states": "States",
    "last_connect": "Letzter Connect",
    "reconnects": "Reconnects",
    "pending": "Offene Handoffs",
    "open_dashboard": "Dashboard öffnen",
    "reconnect": "Verbinden"
  },
  "minimax": {
    "title": "MiniMax Token-Quota",
    "no_data": "Keine Quota-Daten verfügbar.",
    "reset_in": "reset in {{time}}",
    "weekly": "Woche: {{used}} / {{total}} ({{pct}}%)",
    "error_invalid_api_key": "API-Key ungültig",
    "error_network_error": "Netzwerk-Fehler",
    "error_invalid_json": "Antwort konnte nicht gelesen werden",
    "error_upstream_error": "MiniMax-Server-Fehler"
  },
  "backup": {
    "title": "System-Backup",
    "description": "Komplettes Backup von Datenbank, Configs und User-Workspaces. Für Catastrophe-Recovery und Server-Migration.",
    "download": "Backup herunterladen",
    "restore": "Backup wiederherstellen",
    "restore_title": "System wiederherstellen?",
    "restore_warning": "Datei: {{file}}. Aktueller Stand wird automatisch als Rollback gesichert. Service startet nach dem Restore neu.",
    "uploading": "Lade Backup hoch und prüfe Integrität…",
    "waiting_restart": "Restore eingespielt — warte auf Service-Neustart…",
    "restore_done": "Restore abgeschlossen. Bitte neu einloggen.",
    "restore_failed": "Restore fehlgeschlagen.",
    "cancel": "Abbrechen",
    "confirm_restore": "Wiederherstellen",
    "close": "Schließen"
  },
  "migration": {
    "title": "Server-Migration (Voll-Klon)",
    "description": "Überträgt ALLE Daten per rsync auf einen frisch installierten HydraHive2-Server — inklusive Projekte, Git-Repos, Workspaces, VMs und Plattenarchive. Inkrementell und wiederaufnehmbar.",
    "open": "Server klonen",
    "running_short": "Migration läuft…",
    "warning": "Der Ziel-Server muss ein frisch installiertes HydraHive2 haben. ALLE Daten dort werden mit denen dieses Servers überschrieben. Der Ziel-Dienst wird während der Übertragung gestoppt und danach neu gestartet.",
    "host": "Ziel-Host / IP",
    "port": "SSH-Port",
    "user": "SSH-User",
    "password": "SSH-Passwort",
    "bwlimit": "Bandbreiten-Limit (KB/s, 0 = unbegrenzt)",
    "start": "Klon starten",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "running": "Übertragung läuft — das kann bei großen Datenmengen Stunden dauern…",
    "success": "Migration erfolgreich abgeschlossen. Der Ziel-Server ist ein 1:1-Klon.",
    "failure": "Migration fehlgeschlagen — siehe Log.",
    "log_wait": "Warte auf Ausgabe…",
    "err": {
      "migration_already_running": "Es läuft bereits eine Migration.",
      "migration_invalid_host": "Ungültiger Ziel-Host.",
      "migration_invalid_user": "Ungültiger SSH-User."
    }
  },
  "tailscale": {
    "title": "Tailscale",
    "not_installed": "Tailscale ist nicht installiert.",
    "install_hint": "Installiert das Tailscale-Binary und aktiviert tailscaled. Verbinden danach hier mit Auth-Key.",
    "install_button": "Tailscale installieren",
    "installing": "Wird installiert…",
    "install_failed": "Installation fehlgeschlagen",
    "install_success": "Tailscale installiert.",
    "connected": "Verbunden",
    "disconnected": "Nicht verbunden",
    "hostname": "Hostname",
    "dns": "DNS-Name",
    "connect": "Verbinden",
    "logout": "Abmelden",
    "copy_ip": "IP kopieren",
    "copied": "Kopiert!",
    "admin_console": "Admin-Konsole",
    "authkey_hint": "Auth-Key aus dem Tailscale Admin-Panel erstellen:",
    "authkey_placeholder": "tskey-auth-...",
    "error_connect": "Verbindung fehlgeschlagen",
    "error_logout": "Abmeldung fehlgeschlagen",
    "version": "Version",
    "exit_node": "Exit-Node",
    "peers": "Peers im Tailnet ({{count}})",
    "invite_title": "Neuen Node einladen",
    "invite_explainer": "Generiert einen einmaligen Auth-Key (24h gültig) für einen weiteren Server. Voraussetzung: Tailscale-Admin-API-Key unten hinterlegt.",
    "invite_button": "Auth-Key generieren",
    "invite_generating": "Wird generiert…",
    "invite_failed": "Auth-Key konnte nicht generiert werden",
    "invite_copy": "Kopieren",
    "invite_copied": "Kopiert!",
    "invite_expires_at": "Gültig bis {{when}}",
    "admin_settings_toggle": "API-Key-Einstellungen",
    "admin_api_key_label": "Tailscale-API-Key",
    "admin_api_key_placeholder": "tskey-api-...",
    "admin_api_key_hint": "Aus dem Tailscale Admin-Panel → Settings → Keys → API access tokens.",
    "admin_tailnet_label": "Tailnet",
    "admin_tailnet_hint": "'-' nutzt das eigene Tailnet. Ansonsten Tailnet-Name (z.B. example.com).",
    "admin_save": "Speichern",
    "admin_saving": "Wird geprüft…",
    "admin_save_failed": "API-Key wurde von Tailscale abgelehnt",
    "admin_configured": "API-Key hinterlegt",
    "admin_not_configured": "Kein API-Key hinterlegt"
  },
  "samba": {
    "title": "SMB-Shares (Samba)",
    "subtitle": "Projekt-Workspaces als Netzwerk-Share — von Windows/Mac/Linux mountbar.",
    "not_installed": "nicht eingerichtet",
    "running": "läuft",
    "setup": "Samba einrichten",
    "running_setup": "Samba wird eingerichtet…",
    "done": "Samba läuft. Aktiviere pro Projekt in den Settings den Toggle.",
    "failed": "Samba-Setup fehlgeschlagen",
    "timeout": "Setup hat zu lange gebraucht — siehe Log",
    "user": "Login",
    "password": "Passwort",
    "copy": "Kopieren",
    "copied": "Kopiert!"
  },
  "bridge": {
    "title": "Netzwerk-Bridge (br0)",
    "subtitle": "Bridged Networking für VMs und Container — gleiche IP-Range wie der Host.",
    "not_installed": "nicht eingerichtet",
    "setup": "Bridge einrichten",
    "confirm_question": "Bridge jetzt einrichten?",
    "confirm_hint": "Setup ändert die netplan-Konfiguration und ruft `netplan apply` — die Netzwerk-Verbindung kann ~10 Sekunden unterbrochen sein. SSH-Sitzungen können kurz hängen, kommen aber wieder.",
    "confirm_button": "Jetzt einrichten",
    "running": "Bridge wird eingerichtet…",
    "done": "Bridge eingerichtet — VMs/Container haben jetzt LAN-Zugriff.",
    "failed": "Bridge-Setup fehlgeschlagen",
    "timeout": "Setup hat zu lange gebraucht — siehe Log",
    "log_empty": "Noch keine Ausgabe…"
  },
  "settings": {
    "title": "Einstellungen",
    "subtitle": "Integrations-Settings ohne SSH. Die SearXNG-URL greift sofort; Integrationen wie Mail/Discord/AgentLink wirken nach einem Backend-Neustart.",
    "gear_tooltip": "Einstellungen"
  },
  "local_media": {
    "title": "Lokale Bild-/Videogenerierung",
    "subtitle": "ComfyUI auf der eigenen NVIDIA-Grafikkarte: Bilder (SDXL) und Videos (Wan 2.1) ohne Cloud-Kosten.",
    "installed": "installiert",
    "not_installed": "nicht installiert",
    "gpu": "Grafikkarte: {{name}} · {{vram}} GB Grafikspeicher",
    "gpu_none": "Keine NVIDIA-Grafikkarte erkannt",
    "install": "Installieren ({{size}} Download)",
    "uninstall": "Entfernen",
    "blocked_title": "Auf dieser Hardware nicht möglich",
    "blocked": {
      "no_gpu": "Gesperrt: Es wurde keine NVIDIA-Grafikkarte gefunden.",
      "vram_too_small": "Gesperrt: Die Grafikkarte hat zu wenig Grafikspeicher. Nötig sind mindestens {{min}} GB.",
      "disk_too_small": "Gesperrt: Zu wenig freier Speicherplatz ({{free}} frei, nötig {{need}})."
    },
    "confirm_install": "Jetzt installieren? Es werden etwa {{size}} Modelle heruntergeladen ({{free}} frei).",
    "confirm_install_hint": "Das kann je nach Leitung eine Stunde oder länger dauern. HydraHive bleibt währenddessen normal nutzbar.",
    "confirm_install_button": "Jetzt installieren",
    "confirm_uninstall": "Lokale Bild-/Videogenerierung wirklich entfernen?",
    "confirm_uninstall_hint": "Container, Modelle (~{{size}}) und der Eintrag „Lokale GPU“ werden gelöscht. Standard-Modelle, die darauf zeigen, werden zurückgesetzt. Docker selbst bleibt.",
    "confirm_uninstall_button": "Endgültig entfernen",
    "running_install": "Wird installiert… das Log läuft mit.",
    "running_uninstall": "Wird entfernt…",
    "done_install": "Installiert. Die lokalen Modelle stehen jetzt bei Bild und Video zur Auswahl.",
    "done_uninstall": "Entfernt. Das Update installiert es nicht erneut.",
    "failed": "Fehlgeschlagen — Details im Log",
    "log_empty": "Warte auf den Start (bis zu 5 Sekunden)…"
  }
}
